import React from 'react'
import { WhenModel, ExecuteOperationOnPipe, Model, TriggerPipelineOnFormSubmit } from '@morningtrain/react-resources'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import Smartview from 'widgets/smartviews/Smartview'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import Button from 'ui/buttons/Button'
import { Fieldset } from 'layouts/index'
import * as Fields from 'support/fields'
import { Pipeline } from '@morningtrain/react-helpers'

export default function ViewAdminUserSmartview (props) {
  return (
    <Smartview header='Admin bruger'>
      <Model resourceName='users.admins' id={props.id} submittable>

        <WhenModel>
          <SmartviewTextGroup>
            <Fieldset cols={1}>
              <Fields.Input name='name' label='Navn' />
              <Fields.Input name='email' label='E-mail' />
              <Fields.Hidden name='role_name' defaultValue='admin' />
            </Fieldset>
          </SmartviewTextGroup>

          <SmartviewContentSeparator />

          <Button text='Gem bruger' type='submit' />

          <Pipeline>
            <TriggerPipelineOnFormSubmit />
            <ExecuteOperationOnPipe namespace='api' resourceName='users.admins' operationName='index' />
          </Pipeline>
        </WhenModel>

      </Model>
    </Smartview>
  )
}
